import { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import PlayerDashboardButtons from '../../components/player-dashboard-buttons/player-dashboard-buttons';
import { getOnePlayer } from '../../../modules/player_api';
import { getPlayerHomeSessions } from '../../../modules/game_session_api';

import HomePlayForm from './home-play-form';
import HomePlayBulletSection from './home-play-bullet-section';
import HomePlaySessionsTable from './home-play-sessions-table';
import EditProfileSection from './edit-profile-section/edit-profile-section';

import CircleMemberSection from './circle-members/circle-member-section';

import './home-play.css';
class HomePlay extends Component {
  constructor(props) {
    super(props);

    this.state = {
      player_id: -1,
      invalid_player: false,
      player: false,
      home_user: false,
      home_sessions: false,
    };
  }

  activationDone(home_user) {
    this.setState({
      ...this.state,
      home_user: home_user,
      player: { ...this.state.player, home_user: home_user },
    });
  }

  updateHomeUser(homeUser) {
    const { player } = this.state;

    const newPlayer = { ...player };

    newPlayer.home_user = homeUser;
    this.setState({
      home_user: homeUser,
      player: newPlayer,
    });
  }

  async componentDidMount() {
    const playerID = this.props.match.params.id;
    const playerResponse = await getOnePlayer(playerID);

    if (playerResponse.data.success) {
      const playerData = playerResponse.data.player_data;
      this.setState({ player_id: playerID, player: playerData, home_user: playerData.home_user });
    } else {
      this.setState({ invalid_player: true });
    }
    const homeSessionsResponse = await getPlayerHomeSessions(playerID);

    if (homeSessionsResponse.data.success) {
      const homeSessions = homeSessionsResponse.data.home_sessions;
      this.setState({ home_sessions: homeSessions });
    }
  }

  render() {
    const { player, invalid_player, home_user, home_sessions } = this.state;

    let gotPlayer = false;
    if (player) {
      gotPlayer = true;
    }

    let activateHomePlayClass = 'activate_home_play';

    let hasHomeUser = false;
    if (home_user) {
      hasHomeUser = true;
      activateHomePlayClass += ' hide';
    }

    return (
      <div className="home_play_container">
        {gotPlayer && (
          <PlayerDashboardButtons player={player} activePage="homePlay" isTherapistRole={this.props.isTherapistRole} />
        )}

        {gotPlayer && !hasHomeUser && (
          <div className={activateHomePlayClass}>
            <HomePlayBulletSection />
            <HomePlayForm player={player} activation_done={this.activationDone.bind(this)} />
          </div>
        )}

        {gotPlayer && hasHomeUser && (
          <EditProfileSection player={player} update_home_user={this.updateHomeUser.bind(this)} />
        )}

        {hasHomeUser && <CircleMemberSection player={player} home_user={home_user} />}

        {gotPlayer && <HomePlaySessionsTable sessions={home_sessions} player={player} />}
        {invalid_player && <div>Invalid Player</div>}
      </div>
    );
  }
}

const withState = connect((state) => {
  const { user } = state;

  return {
    isTherapistRole: user.isTherapistRole,
  };
});

export default withRouter(withState(HomePlay));
